const css = `.sync-course-request label {
  color: rgba(64, 64, 65, 0.8392156863);
  font-weight: 300;
}
.sync-course-request .ant-select-multiple .ant-select-selection-item {
  border: solid 1px #131396;
  border-radius: 50px;
  background: #edeff5;
  color: #131396;
}
.sync-course-request .ant-select-multiple .ant-select-selection-overflow-item-rest .ant-select-selection-item {
  background: #3a3b3d;
  color: white;
}
.sync-course-request .ant-radio-inner,
.sync-course-request .ant-radio-wrapper:hover {
  border-color: #131396;
}
.sync-course-request .ant-radio-inner .ant-radio .ant-radio-inner,
.sync-course-request .ant-radio-wrapper:hover .ant-radio .ant-radio-inner {
  border-color: #131396;
}
.sync-course-request .ant-radio-input:focus + .ant-radio-inner {
  box-shadow: 0 0 0 3px #edeff5;
  border-color: #131396;
}
.sync-course-request .ant-radio-checked ::after {
  background-color: #131396;
}

.empty-checkbox {
  display: block;
  border: solid 0.5px #131396;
  height: 1rem;
  width: 1rem;
}

.ant-select-item {
  transition: none;
}

.ant-select-item-option-content,
.ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
  color: #3a3b3d;
  font-weight: 300;
}
.ant-select-item-option-content .anticon-check-square,
.ant-select-item-option-selected:not(.ant-select-item-option-disabled) .anticon-check-square {
  color: #131396;
}
.ant-select-item-option-content .ant-select-item-option-state,
.ant-select-item-option-selected:not(.ant-select-item-option-disabled) .ant-select-item-option-state {
  color: black;
}

.ant-select-item-option-active:not(.ant-select-item-option-disabled) {
  background: #edeff5;
}
.ant-select-item-option-active:not(.ant-select-item-option-disabled) .ant-select-item-option-content {
  background: #edeff5;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL1VzZXJzL2RpeGl0LmphaW4vZGF0YS1pbmdlc3QvYXBwcy9kYXRhLWluZ2VzdC11aS9zcmMvYXBwL2NvbnRhaW5lcnMvU3luY0NvdXJzZVJlcXVlc3QiLCJzb3VyY2VzIjpbInN0eWxlcy5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUlFO0VBQ0U7RUFDQTs7QUFJQTtFQUNFO0VBQ0E7RUFDQSxZQVpDO0VBYUQsT0FkUzs7QUFrQlQ7RUFDRTtFQUNBOztBQUtOO0FBQUE7RUFFRSxjQTNCVzs7QUE2Qlg7QUFBQTtFQUNFLGNBOUJTOztBQW1DWDtFQUNFO0VBQ0EsY0FyQ1M7O0FBMENYO0VBQ0Usa0JBM0NTOzs7QUFnRGY7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTs7O0FBRUY7QUFBQTtFQUVFO0VBQ0E7O0FBR0E7QUFBQTtFQUNFLE9BakVXOztBQW9FYjtBQUFBO0VBQ0U7OztBQUlKO0VBQ0UsWUF6RUs7O0FBMEVMO0VBQ0UsWUEzRUciLCJzb3VyY2VzQ29udGVudCI6WyIkcHJpbWFyeV9ibHVlOiAjMTMxMzk2O1xuJGdyYXk6ICNlZGVmZjU7XG5cbi5zeW5jLWNvdXJzZS1yZXF1ZXN0IHtcbiAgbGFiZWwge1xuICAgIGNvbG9yOiAjNDA0MDQxZDY7XG4gICAgZm9udC13ZWlnaHQ6IDMwMDtcbiAgfVxuXG4gIC5hbnQtc2VsZWN0LW11bHRpcGxlIHtcbiAgICAuYW50LXNlbGVjdC1zZWxlY3Rpb24taXRlbSB7XG4gICAgICBib3JkZXI6IHNvbGlkIDFweCAkcHJpbWFyeV9ibHVlO1xuICAgICAgYm9yZGVyLXJhZGl1czogNTBweDtcbiAgICAgIGJhY2tncm91bmQ6ICRncmF5O1xuICAgICAgY29sb3I6ICRwcmltYXJ5X2JsdWU7XG4gICAgfVxuXG4gICAgLmFudC1zZWxlY3Qtc2VsZWN0aW9uLW92ZXJmbG93LWl0ZW0tcmVzdCB7XG4gICAgICAuYW50LXNlbGVjdC1zZWxlY3Rpb24taXRlbSB7XG4gICAgICAgIGJhY2tncm91bmQ6ICMzYTNiM2Q7XG4gICAgICAgIGNvbG9yOiB3aGl0ZTtcbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICAuYW50LXJhZGlvLWlubmVyLFxuICAuYW50LXJhZGlvLXdyYXBwZXI6aG92ZXIge1xuICAgIGJvcmRlci1jb2xvcjogJHByaW1hcnlfYmx1ZTtcblxuICAgIC5hbnQtcmFkaW8gLmFudC1yYWRpby1pbm5lciB7XG4gICAgICBib3JkZXItY29sb3I6ICRwcmltYXJ5X2JsdWU7XG4gICAgfVxuICB9XG5cbiAgLmFudC1yYWRpby1pbnB1dDpmb2N1cyB7XG4gICAgKyAuYW50LXJhZGlvLWlubmVyIHtcbiAgICAgIGJveC1zaGFkb3c6IDAgMCAwIDNweCAkZ3JheTtcbiAgICAgIGJvcmRlci1jb2xvcjogJHByaW1hcnlfYmx1ZTtcbiAgICB9XG4gIH1cblxuICAuYW50LXJhZGlvLWNoZWNrZWQge1xuICAgIDo6YWZ0ZXIge1xuICAgICAgYmFja2dyb3VuZC1jb2xvcjogJHByaW1hcnlfYmx1ZTtcbiAgICB9XG4gIH1cbn1cblxuLmVtcHR5LWNoZWNrYm94IHtcbiAgZGlzcGxheTogYmxvY2s7XG4gIGJvcmRlcjogc29saWQgMC41cHggJHByaW1hcnlfYmx1ZTtcbiAgaGVpZ2h0OiAxcmVtO1xuICB3aWR0aDogMXJlbTtcbn1cblxuLmFudC1zZWxlY3QtaXRlbSB7XG4gIHRyYW5zaXRpb246IG5vbmU7XG59XG4uYW50LXNlbGVjdC1pdGVtLW9wdGlvbi1jb250ZW50LFxuLmFudC1zZWxlY3QtaXRlbS1vcHRpb24tc2VsZWN0ZWQ6bm90KC5hbnQtc2VsZWN0LWl0ZW0tb3B0aW9uLWRpc2FibGVkKSB7XG4gIGNvbG9yOiAjM2EzYjNkO1xuICBmb250LXdlaWdodDogMzAwO1xuICAvL2JhY2tncm91bmQ6IHdoaXRlO1xuXG4gIC5hbnRpY29uLWNoZWNrLXNxdWFyZSB7XG4gICAgY29sb3I6ICRwcmltYXJ5X2JsdWU7XG4gIH1cblxuICAuYW50LXNlbGVjdC1pdGVtLW9wdGlvbi1zdGF0ZSB7XG4gICAgY29sb3I6IGJsYWNrO1xuICB9XG59XG5cbi5hbnQtc2VsZWN0LWl0ZW0tb3B0aW9uLWFjdGl2ZTpub3QoLmFudC1zZWxlY3QtaXRlbS1vcHRpb24tZGlzYWJsZWQpIHtcbiAgYmFja2dyb3VuZDogJGdyYXk7XG4gIC5hbnQtc2VsZWN0LWl0ZW0tb3B0aW9uLWNvbnRlbnQge1xuICAgIGJhY2tncm91bmQ6ICRncmF5O1xuICB9XG59XG4iXX0= */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
